import { Component, OnInit } from '@angular/core';
import { GlobalService } from 'src/app/api/global.service';
import { ActivatedRoute, Router } from '@angular/router';
import * as _ from 'underscore';
import { FormBuilder } from '@angular/forms';
import { environment } from 'src/app/environment';
import { NavigationTrackerService } from 'src/app/utils/navigation-tracker.service';
import { OpeningService } from 'src/app/api/money/opening.service';
import { ToolsService } from 'src/app/utils/tools.service';
declare var $: any;

@Component({
  selector: 'app-historybox-detail',
  templateUrl: './historybox-detail.component.html',
  styleUrls: ['./historybox-detail.component.css']
})
export class HistoryboxDetailComponent implements OnInit {
  branchofficeSlug: string = '';
  checkId: number;
  submitted: boolean = false;
  txtSubmenu: string = environment.txt_create_menu_form;
  isEdit: boolean = false;
  item: any = null;
  incomes: any = [];
  expenses: any = [];

  constructor(
    public fb: FormBuilder,
    private router: Router,
    private globalService: GlobalService,
    private openingService: OpeningService,
    public toolsService: ToolsService,
    private route: ActivatedRoute,
    private navigationTrackerService: NavigationTrackerService
  ) {
    this.branchofficeSlug = this.globalService.slugBranchoffice;
    this.checkId = this.route.snapshot.params['id'];
    if (!_.isUndefined(this.checkId)) {
      this.txtSubmenu = environment.txt_edit_menu_form;
      this.isEdit = true;
    }
  }

  ngOnInit() {
    this.navigationTrackerService.initializeMenu(this.route);
    if (this.isEdit) {
      this.openingService.getHistoryBoxDetail(this.checkId).subscribe({
        next: (data: any) => {
          this.item = data.data;
          this.incomes = Object.values(data.incomes);
          this.expenses = Object.values(data.expenses);
          if (this.item.amount_closing == null) {
            this.item.amount_closing = 0;
          }
        }
      });
    }
  }

  onSubmit() {
    this.submitted = true;
  }

  validate() {
    return true;
  }

  printer() {
    (<any>$('#body')).printThis({
      importCSS: true,
      importStyle: true
    });
  }

  refresh() {
    this.ngOnInit();
  }

  cancel() {
    this.router.navigate([this.branchofficeSlug + '/caja/historialcaja/lista']);
  }
  
}
